import { lazy } from 'react';

const CAMEnableSchoolsModal = lazy(() =>
  import('./components/modals/CAMEnableSchoolsModal'),
);
const ProjectSetupModal = lazy(() =>
  import('./components/modals/ProjectSetupModal'),
);

export default {
  PROJECT_SETUP_MODAL: ProjectSetupModal,
  CAM_ENABLE_SCHOOLS_MODAL: CAMEnableSchoolsModal,
};
